import React, { useState } from 'react';
import { Calendar, Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
export function HeaderBookACall() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setMobileMenuOpen(false);
    }
  };
  const navItems = [{
    label: 'Inicio',
    id: 'hero'
  }, {
    label: 'Beneficios',
    id: 'beneficios'
  }, {
    label: 'Proceso',
    id: 'proceso'
  }, {
    label: 'Resultados',
    id: 'resultados'
  }];
  return <header className="fixed top-0 left-0 right-0 bg-black border-b border-gray-900 z-50 shadow-lg" data-id="element-307" data-mp="3rdq8bnjzu2xt">
      <div className="container mx-auto px-4" data-id="element-308" data-mp="33nm35br5pv4p">
        <div className="flex items-center justify-between h-14 md:h-16 lg:h-20" data-id="element-309" data-mp="33mazdbxpondl">
          {/* Logo with Text - Left Side */}
          <button onClick={() => scrollToSection('hero')} className="flex items-center gap-2 md:gap-3 focus:outline-none focus:ring-2 focus:ring-[#7FFF00] rounded-lg" data-id="element-310" data-mp="2ymyegwqehqdn">
            <img src="https://cdn.magicpatterns.com/uploads/pQpn8iHP7HBroEb2DfK46p/WhatsApp_Image_2025-12-04_at_16.35.08.jpg" alt="Info Commerce AI" className="h-7 md:h-9 lg:h-10 w-auto" data-id="element-311" data-mp="2734riyyunu9z" />
            <span className="text-white font-bold text-sm md:text-base lg:text-lg tracking-tight" data-id="element-312" data-mp="2gt7jcvu8j26q">
              Info Commerce AI
            </span>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-5 lg:space-x-8" data-id="element-313" data-mp="1o6dakw6s5r93">
            {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-gray-100 hover:text-[#7FFF00] transition-colors text-sm font-medium" data-id="element-314" data-mp="1t3d7aghqphnj">
                {item.label}
              </button>)}
            <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-claridad-crea-tu-producto-digital-con-ia" target="_blank" rel="noopener noreferrer" data-id="element-315" data-mp="34m652o2ysanz">
              <Button variant="primary" size="md" className="bg-[#7FFF00] hover:bg-[#6FEF00] text-black font-bold text-sm" leftIcon={<Calendar className="w-4 h-4" data-id="element-317" data-mp="14jy86w4yb9zj" />} data-id="element-316" data-mp="19fdije3r2nr7">
                <span className="hidden lg:inline" data-id="element-318" data-mp="1ihv5xvv55mfs">Agenda tu Llamada</span>
                <span className="lg:hidden" data-id="element-319" data-mp="1diihx7sja9bm">Agendar</span>
              </Button>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-white p-2 hover:bg-gray-900 rounded-lg transition-colors" aria-label={mobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} data-id="element-320" data-mp="ptr09ackl9d3">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-321" data-mp="zklm4dlwm6y0" /> : <Menu className="w-6 h-6" data-id="element-322" data-mp="usajh2zs471r" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && <nav className="md:hidden py-3 border-t border-gray-900" data-id="element-323" data-mp="71enrus7crp8">
            <div className="flex flex-col space-y-1" data-id="element-324" data-mp="23mtwv7zyvie">
              {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-gray-100 hover:text-[#7FFF00] transition-colors text-left py-2.5 px-4 hover:bg-gray-900 rounded-lg text-base font-medium" data-id="element-325" data-mp="21it4m5eacmc">
                  {item.label}
                </button>)}
              <div className="pt-2 px-4" data-id="element-326" data-mp="24rldmzkzjuxi">
                <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-claridad-crea-tu-producto-digital-con-ia" target="_blank" rel="noopener noreferrer" className="block" data-id="element-327" data-mp="29ovdza9wxr04">
                  <Button variant="primary" size="md" className="w-full bg-[#7FFF00] hover:bg-[#6FEF00] text-black font-bold" leftIcon={<Calendar className="w-5 h-5" data-id="element-329" data-mp="2nhbads8b6qs2" />} data-id="element-328" data-mp="31g15x3fhcieb">
                    Agenda tu Llamada
                  </Button>
                </a>
              </div>
            </div>
          </nav>}
      </div>
    </header>;
}